export default {"src":"/_next/static/media/scholarship_under_review.8a3e52cc.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};